<div class="h-full w-full">
  <div class="flex justify-center items-center h-screen">
    <div
      class="rounded-2xl bg-[#fff] h-full w-full"
      style="
        background-image: url('/src/assets/images/emblembg.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 33%;
      "
    >
      <div class="my-4 mx-3">
        <!-- BEGIN: Page button -->
        <app-page-title [title]="title" [useBackButton]="true"></app-page-title>
        <!-- END: Page button -->
      </div>

      <div class="container-fluid">
        <div class="row h-20 rounded-lg flex items-center">
          <div class="col">
            <div class="flex justify-end">
              <div class="flex items-end">
                <button
                mat-raised-button
                class="add-button"
                  (click)="addEditApprovalFlow()"
                  *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']"
                >
                    <mat-icon svgIcon="add"></mat-icon>
                    <span class="mx-1">
                      Add Approval Flow
                    </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BEGIN: User table -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="col-md-12 move-left">
              <app-data-table-hybrid
                [columnHeader]="tableColumns"
                [tableData]="tableData"
                [isPageable]="false"
              >
                <ng-template #actions let-data="data">
                  <!-- BEGIN: Table actions -->
                  <div class="action-icons">
                    <!-- BEGIN: View category -->

                    <ng-container *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">
                      <span class="icon-holder color-primary" matTooltip="View More" matTooltipPosition="left"
                      [routerLink]="(from === 'INST' ? '/settings/approval-flow-setting-list/' : '/system-settings/approval-flow-setting-list/')+data?.flowUniqueId"
                      matTooltipClass="primary-tooltip">
                      <mat-icon svgIcon="list"></mat-icon>
                      </span>
                    </ng-container>


                    <!-- END: View category -->
                    <!-- BEGIN: Edit -->

                    <ng-container *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">
                      <span class="icon-holder color-primary" matTooltip="Edit " matTooltipPosition="left"
                         (click)="addEditApprovalFlow(data)"
                            matTooltipClass="primary-tooltip">
                          <mat-icon svgIcon="edit"></mat-icon>
                      </span>
                    </ng-container>
                    <!-- END: Edit -->


                    <!-- BEGIN: Delete category -->
                    <ng-container *ngxPermissionsOnly="['can_manage_institution_settings', 'can_manage_system_settings']">
                      <span class="icon-holder color-danger" matTooltip="Delete Service" matTooltipPosition="left"
                            (click)="deleteApprovalFlow(data)" matTooltipClass="danger-tooltip">
                          <mat-icon svgIcon="delete"></mat-icon>
                      </span>
                    </ng-container>

                    <!-- END: Delete category -->
                  </div>
                  <!-- END: Table actions -->

                </ng-template>
              </app-data-table-hybrid>
            </div>
          </div>
        </div>
      </div>
      <!-- END: User table -->
    </div>
  </div>
</div>
